import { debounce } from 'lodash';
import classify from '../../helpers/classify';
import { CMS_COMPONENT_YOUTUBE, YOUTUBE_VIDEO, CMS_MEDIA_CONTAINER } from './index';

const loadYoutubeScript = (): void => {
  if (!window.YT) {
    const tag = document.createElement('script');

    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag?.parentNode?.insertBefore(tag, firstScriptTag);
  }
};

const updateFullHeightVideoSize = (videoEl: HTMLDivElement): void => {
  videoEl.style.width = '100%';
  videoEl.style.height = '100%';
  if (window.matchMedia('(min-width: 768px)').matches) {
    const videoWidth = videoEl.offsetHeight * (16 / 9);
    videoEl.style.width = `${videoWidth}px`;
  } else {
    const videoHeight = videoEl.offsetWidth * (9 / 16);
    videoEl.style.height = `${videoHeight}px`;
  }
};

const updateVideoSize = (videoEl: HTMLDivElement): void => {
  const cmsComponent = videoEl.closest<HTMLDivElement>(classify(CMS_COMPONENT_YOUTUBE));
  const mediaContainers = cmsComponent?.querySelectorAll<HTMLDivElement>(classify(CMS_MEDIA_CONTAINER));
  let videoHeight: number;

  videoHeight = videoEl.offsetWidth * (9 / 16); // 16:9 aspect ratio

  if (cmsComponent && cmsComponent.classList.contains('cms-hero-promo')) {
    videoHeight = cmsComponent.offsetWidth * (9 / 16); // 16:9 aspect ratio
  }

  videoEl.style.height = `${videoHeight}px`;
  if (mediaContainers?.length) {
    mediaContainers.forEach((mediaContainer) => {
      mediaContainer.style.height = `${videoHeight}px`;
    });
  }
};

// eslint-disable-next-line import/prefer-default-export
export const initAllCmsYoutubeVideos = (): void => {
  const youtubeVideos = document.querySelectorAll<HTMLIFrameElement>(classify(YOUTUBE_VIDEO));
  const fullHeightYoutubeVideos = document.querySelectorAll<HTMLIFrameElement>(
    `.cms-combo-carousel--fullHeightImage .${YOUTUBE_VIDEO}`
  );

  if (!youtubeVideos.length) {
    return;
  }

  loadYoutubeScript();

  window.onYouTubeIframeAPIReady = (): void => {
    youtubeVideos.forEach((video) => {
      let player;
      const videoObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            player.playVideo();
          } else {
            player.pauseVideo();
          }
        });
      });

      video.onload = (): void => {
        player = new window.YT.Player(video, {
          events: {
            onReady: (event): void => {
              event.target.playVideo();
              videoObserver.observe(video);
            }
          }
        });
      };
    });
  };

  const setResizeListener = (
    elements: HTMLDivElement[] | NodeListOf<HTMLDivElement>,
    callback: (videoEl: HTMLDivElement) => void
  ): void => {
    elements.forEach(callback);

    window.addEventListener(
      'resize',
      debounce(() => {
        elements.forEach(callback);
      }, 100)
    );
  };

  if (fullHeightYoutubeVideos.length) {
    const youtubeVideosArr = Array.from(youtubeVideos);
    const fullHeightYoutubeVideosArr = Array.from(fullHeightYoutubeVideos);
    const nonFullHeightYoutubeVideos = youtubeVideosArr.filter((video) => !fullHeightYoutubeVideosArr.includes(video));

    setResizeListener(fullHeightYoutubeVideos, updateFullHeightVideoSize);
    setResizeListener(nonFullHeightYoutubeVideos, updateVideoSize);

    return;
  }

  setResizeListener(youtubeVideos, updateVideoSize);
};
